var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cool-off" },
    [
      _c("div", { staticClass: "tabr-wrapper" }, [
        _c("div", { staticClass: "tabr-chld-header" }, [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("Account.Exclusions.CoolOff.Header")))
          ])
        ]),
        _vm._v(" "),
        _vm.expiryDate
          ? _c("div", { key: "exl-info-msg", staticClass: "tabr-info-msg" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("Account.Exclusions.CoolOff.BreakUntil")) +
                  " " +
                  _vm._s(
                    _vm._f("moment")(_vm.expiryDate, _vm.dateFormats.longDate)
                  ) +
                  _vm._s(", ") +
                  " " +
                  _vm._s(
                    _vm._f("moment")(_vm.expiryDate, _vm.dateFormats.longTime)
                  )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tabr-chld-info" }, [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("Account.Exclusions.CoolOff.Desc.One")))
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("Account.Exclusions.CoolOff.Desc.Two")))
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("Account.Exclusions.CoolOff.Desc.Three")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ctsform accpage" }, [
          _c(
            "div",
            { staticClass: "control-block", class: { filled: _vm.duration } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.duration,
                    expression: "duration"
                  }
                ],
                attrs: {
                  type: "number",
                  min: "3",
                  max: "365",
                  inputmode: "numeric",
                  autocomplete: "off"
                },
                domProps: { value: _vm.duration },
                on: {
                  keypress: function($event) {
                    return _vm.validateInput()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.duration = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { key: "tbd_label", staticClass: "control-label" }, [
                _vm._v(_vm._s(_vm.$t("Account.Exclusions.CoolOff.Duration")))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabr-chld-btns" },
          [
            _c(
              "v-btn",
              {
                attrs: { color: "success", disabled: !_vm.durationIsValid },
                on: {
                  click: function($event) {
                    return _vm.takeABreak()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Statement.dialog.Apply")))]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Text"
            ),
            successTitle: _vm.$t("Account.Exclusions.CoolOff.Success.Title"),
            successText: _vm.$t("Account.Exclusions.CoolOff.Success.Text"),
            errorTitle: _vm.$t("Account.Exclusions.CoolOff.Failed"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _c(
              "p",
              { staticClass: "generic-icon-note" },
              [
                _c(
                  "v-icon",
                  { staticClass: "mr-1", attrs: { color: "error" } },
                  [_vm._v("error")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.transactionError))])
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8c32f3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8c32f3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Exclusions/CoolOffBreak.vue
// module id = null
// module chunks = 